var _path, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMapIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 30,
    viewBox: "0 0 24 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0002 0.00708008C5.70867 0.00708008 0.577148 5.1386 0.577148 11.4302C0.577148 13.9256 1.36793 16.2981 2.86184 18.2839L11.2972 29.6485C11.4201 29.8241 11.7541 29.9999 12.0002 29.9999C12.2639 29.9999 12.5803 29.8066 12.7032 29.6484C12.7378 29.5963 21.0272 18.4294 21.2909 18.0639C21.2981 18.0538 21.3094 18.0628 21.3136 18.0511C21.3161 18.0439 21.3169 18.0346 21.3213 18.0283C22.6877 16.0972 23.4233 13.8162 23.4233 11.4302C23.4233 5.13866 18.2918 0.00708008 12.0002 0.00708008ZM12.0002 17.581C8.60859 17.581 5.84936 14.8219 5.84936 11.4302C5.84936 8.03841 8.60859 5.27929 12.0002 5.27929C15.3919 5.27929 18.1511 8.03841 18.1511 11.4302C18.1511 14.8219 15.3919 17.581 12.0002 17.581Z",
    fill: "url(#paint0_linear_39_8819)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_39_8819",
    x1: 0.577148,
    y1: 0.00708008,
    x2: 23.9464,
    y2: 0.420414,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC2B6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BC00A9"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapIcon);
export default __webpack_public_path__ + "static/media/MapIcon.cfd75ef3927c8ac6a5ee54a38a499da5.svg";
export { ForwardRef as ReactComponent };